import Sokanzu from "./_sokanzu.es6";
import PointGet from "./_pointget.es6";
import Main from "./_main.es6";

const main = new Main();
const sokanzu = new Sokanzu();
const pointget = new PointGet();